import { PermissionsState } from './permissions.types';

export const initialPermissionsState: PermissionsState = {
    flags: {
        users_id: 0,
        user_information: true,
        commercial_cart: true,
        vigencias: false,
        asignaciones: false,
        slots_comerciales: false,
        panel_comerciales: false,
        transacciones: false,
        transacciones_todas: false,
    },
    status: 'idle',
    error: null,
};
